<template>
  <v-card
      flat
      max-width="600"
      mim-width="350"
      class="mx-auto"
  >
    <v-toolbar density="compact" color="white" title="모바일 회원권">
    </v-toolbar>

    <v-card
        v-if="membershipInfo.length > 0"
        class="pa-4"
        color="grey-lighten-3"
        flat>
      <v-row>
        <v-col cols="3">
          <div class="pt-2 text-end">
            회원번호
          </div>
        </v-col>
        <v-col cols="8">
          <v-select
              :items="membershipInfo"
              v-model="selectedMembership"
              @update:modelValue="generateQrCode"
              class="bg-white"
              density="compact"
              variant="outlined"
              location="bottom"
              item-title="value"
              item-value="key"
              single-line
              label="회원번호 선택"
              hide-details></v-select>
        </v-col>
      </v-row>
      <div id="qr-code-img" class="bg-grey-lighten-3">
        <v-row>
          <v-col cols="12">
            <v-card-text v-if="qrCode === null" class="mt-6 text-center text-body-1">
              회원번호를 선택해주세요.
            </v-card-text>
            <v-img class="mx-auto ma-4" justify="center" width="150">
              <qrcode-vue v-if="qrCode !== null" :value="qrCode" size="150" level="H"></qrcode-vue>
            </v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0" cols="12">
            <div class="text-center" v-if="notice1 !== null">
              {{notice1}}
            </div>
            <div class="text-center" v-if="notice2 !== null">
              {{notice2}}
            </div>
            <div class="text-center" v-if="notice3 !== null">
              {{notice3}}
            </div>
          </v-col>
        </v-row>
      </div>
      <v-row class="pb-4">
        <v-col cols="12">
          <div class="text-center">
            <v-btn class="bg-primary" variant="outlined" :disabled="!selectedMembership" @click="downloadQr()">다운로드</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-card v-if="membershipInfo.length <= 0"
            class="mt-2"
            color="grey-lighten-4"
            flat>
      <v-card-text class="text-body-2 text-center">회원권을 보유한 고객을 위한 페이지 입니다.</v-card-text>
      <v-card-text class="pt-0 text-center">
        <v-btn color="primary" to="/" variant="tonal">홈으로 이동</v-btn>
      </v-card-text>
    </v-card>
  </v-card>

  <MobileFooter></MobileFooter>
</template>

<script>
import MobileFooter from "@/components/common/MobileFooter";
import {auth} from "@/api";
import QrcodeVue from 'qrcode.vue';
import dayjs from "dayjs";
import commonStore from "@/store/common";
import domtoimage from "dom-to-image-more"

export default {
  name: "Membership",
  components: {MobileFooter, QrcodeVue},
  data () {
    return {
      membershipInfo: [],
      validityPeriod: '',
      qrCode: null,
      selectedMembership: '',
      notice1: '',
      notice2: '',
      notice3: '',
    }
  },
  created() {
    this.getMembershipInfo()
    this.validityPeriod = dayjs().format('YYYY-MM-DD')
  },
  methods: {
    getMembershipInfo() {
      auth.getMembershipInfo(commonStore.state.common.corpCode)
          .then(data => {
            console.log(data)
            if (data.data.memberships) {
              data.data.memberships.forEach((item,index) => {
                this.membershipInfo.push({key:index+1, value:item.MBNO, item:item})
              })
            }
            console.log(this.membershipInfo)
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    generateQrCode() {
      this.qrCode = this.membershipInfo[this.selectedMembership-1].item.REF1
      this.notice1 = this.membershipInfo[this.selectedMembership-1].item.REF2
      this.notice2 = this.membershipInfo[this.selectedMembership-1].item.REF3
      this.notice3 = this.membershipInfo[this.selectedMembership-1].item.REF4

    },
    downloadQr() {
      const node = document.getElementById('qr-code-img');

      domtoimage.toJpeg(node, { quality: 0.95 })
          .then(function (dataUrl) {
            const link = document.createElement('a');
            link.download = '모바일회원권_' + dayjs().format('YYYYMMDD') + '.jpg';
            link.href = dataUrl;
            link.click();
          });
    },
  }
}
</script>

<style scoped>

</style>